import * as React from 'react';
import { CalendarViewMode } from '../redux-state/interfaces/calendar-settings';
import { CalendarContainerProps } from './calendar-container';
import LoaderView from './loader';
import ListMonthContainer from './list/container';
import GridMonthContainer from './grid/container';
import MiniCalendarContainer from './mini-calendar/container';
import Responsive from './responsive/index'
const CalendarContainerView: React.StatelessComponent<CalendarContainerProps> = props => {
    let component: JSX.Element = null;

    if (props.calendarViewMode === CalendarViewMode.LIST) {
        component = <div className="ace-cal-main block-inner">
            <section className="grid-container ace-cal-results ">
                <MiniCalendarContainer />
                <ListMonthContainer />
                <LoaderView />
            </section>
        </div>
    } else {
        component = <GridMonthContainer />;
    }
     
    return (
        <>
            <LoaderView />
            {component}
        </>
    )
}

export default CalendarContainerView;